import { createSlice } from "@reduxjs/toolkit";

export enum ItemDisplayType {
    Search = "search",
    Click = "click",
}

interface SearchState {
    searchResults: any[];
    searchResultsOpen: boolean;
    clickResultsLoading: boolean;
    searchResultsLoading: boolean;
    catalogLoading: boolean;
    searchItemDisplayType: string;
}

const initialState: SearchState = {
    searchResults: [],
    searchResultsOpen: false,
    clickResultsLoading: false,
    searchResultsLoading: false,
    catalogLoading: false,
    searchItemDisplayType: ItemDisplayType.Search,
};

const searchSlice = createSlice({
    name: "search",
    initialState,
    reducers: {
        setSearchResults(state, action) {
            state.searchResults = action.payload;
        },
        setSearchResultsOpen(state, action) {
            state.searchResultsOpen = action.payload;
        },
        setClickResultsLoading(state, action) {
            state.clickResultsLoading = action.payload;
        },
        setSearchResultsLoading(state, action) {
            state.searchResultsLoading = action.payload;
        },
        setCatalogLoading(state, action) {
            state.catalogLoading = action.payload;
        },
        setSearchItemDisplayType(state, action) {
            state.searchItemDisplayType = action.payload;
        },
    },
});

export default searchSlice.reducer;
export const {
    setSearchResults,
    setSearchResultsOpen,
    setClickResultsLoading,
    setSearchResultsLoading,
    setCatalogLoading,
    setSearchItemDisplayType,
} = searchSlice.actions;
export type { SearchState };
